import React, { useState, useRef } from 'react';
import { useEffect } from 'react';

export const UnefonIlimitado2 = React.memo(({oferta1}) => {
    const [beneficios, setBeneficios] = useState([]);
    
    const [regalos, setRegalos] = useState([]);

    const dias = useRef();

    let ofertaViene = oferta1;


    const getAgrupados = () =>{
      let grupo = [];
        oferta1.beneficiosBase.map((ofr)=>{
          if(ofr.section === 3){
            grupo = [...grupo, ofr]
          }
          if(Number(ofr.topupAmount) === 10){
            dias.current = "/"+ofr.validity
          }
      });
        return grupo;
    }

    const getBeneficios = () => {
        let beneficiosBaseArray = [];
        let grupo3 = getAgrupados();
        let ofrr = {};
        oferta1.beneficiosBase.map((ofr)=>{
          if(ofr.section !== 3){
            beneficiosBaseArray = [...beneficiosBaseArray, ofr];
          }
      });
        
        if(grupo3.length){
          grupo3.map((gr)=>{
            if(gr.groupId !== -1){
              ofrr = gr;
            }else{
              if(gr.benefitDescription == "WhatsApp"){
                ofrr.section = 3;
                ofrr.benefitQuantity = gr.validity  +" "+gr.benefitDescription  +" "+ gr.benefitQuantity;
                beneficiosBaseArray = [...beneficiosBaseArray, ofrr];
              }else{
                ofrr.benefitQuantity = gr.benefitQuantity  +" y "+ ofrr.benefitQuantity;
                beneficiosBaseArray = [...beneficiosBaseArray, ofrr];
              }
              
            }
          });
        }
        setBeneficios(beneficiosBaseArray);
    }

    const [esVideo, setEsvideo] = useState(false);

    const getRegalos = () => {
        let benefociosRegalo = [];
        oferta1.beneficiosOferta.map((ofr)=>{
          if(ofr.benefitDescription.includes("Spotify")||ofr.benefitDescription.includes("YouTube")||ofr.benefitDescription.includes("Min/SMS/WhatsApp")){
            setEsvideo(true);
          }
            benefociosRegalo = [...benefociosRegalo, ofr]
        });
        //Por si vienen objetos repetidos los filtramos
        const sinrepetidos = benefociosRegalo.filter((v,i,a)=>a.findIndex(v2=>(v2.id===v.id))===i);
        setRegalos(sinrepetidos);
    }

    useEffect(() => {
        getBeneficios();
        getRegalos();
    }, [])


  return (
    <>
        <div className="dias10">
          {dias.current}
        </div>
        <div className="contenedorDatos">
            { 
                 beneficios.map((sub, index) =>
                      <div key={index} >
                      
                        {
                          sub.section === 3 && <div className='elmas'>+</div> 
                        }
                        <div className="datoMulti">
                          <div className="cantidadM">
                         
                            
                            {
                              Number(sub.topupAmount) === 10
                              ? <> <div>{sub.benefitQuantity}</div> {sub.benefitDescription}</> 
                              :<>{sub.validity} <div>{sub.benefitQuantity}</div> {sub.benefitDescription}</> 
                            }

                            
                          
                          </div> 
                        </div>
                        
                      </div>
                    )
             }
        </div>

        <div className="contenedorRegalo3">
            { 
                 regalos.map((sub, index) =>
                      <div key={index} className="dataMultiReg">
                        
                        {
                          esVideo
                          ? <div className="cantidadM">{sub.benefitDescription} con vigencia de {sub.validity}</div>
                          : <div className="cantidadM">{sub.validity} {sub.benefitDescription}  </div>
                        }
                        
                        	<div className="adicional">
	                            {
	                                (sub.validity.trim().toLowerCase().includes('s'))  ? "Adicionales" : "Adicional"
	                            }
                            </div>
                        
                        
                        
                      </div>
                    )
             }
        </div>

    
    </>
  )
}
)